import { Box } from '@mui/material';
import { STREAM_UI_CONFIG } from '../../consts';

/**
 * Stronger gutter between stacked focus tracks (e.g. Live Topics → Personas).
 * Recessed band + hairlines so tracks read as separate rows, not one dense block.
 */
export function FocusTracksSeparator() {
  return (
    <Box
      sx={{
        height: STREAM_UI_CONFIG.focusTracksSeparatorHeight,
        flexShrink: 0,
        borderBottom: 1,
        borderColor: 'divider',
      }}
    />
  );
}
